import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Inject, Injectable, SkipSelf, NgModule } from '@angular/core';
import { HttpUrlEncodingCodec, HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';

/**
* CustomHttpUrlEncodingCodec
* Fix plus sign (+) not encoding, so sent as blank space
* See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
*/
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(k) {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B');
    }
    encodeValue(v) {
        v = super.encodeValue(v);
        return v.replace(/\+/gi, '%2B');
    }
}

const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
};

class Configuration {
    constructor(configurationParameters = {}) {
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
    }
    /**
     * Select the correct content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param contentTypes - the array of content types that are available for selection
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderContentType(contentTypes) {
        if (contentTypes.length == 0) {
            return undefined;
        }
        let type = contentTypes.find(x => this.isJsonMime(x));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    }
    /**
     * Select the correct accept content-type to use for a request.
     * Uses {@link Configuration#isJsonMime} to determine the correct accept content-type.
     * If no content type is found return the first found type if the contentTypes is not empty
     * @param accepts - the array of content types that are available for selection.
     * @returns the selected content-type or <code>undefined</code> if no selection could be made.
     */
    selectHeaderAccept(accepts) {
        if (accepts.length == 0) {
            return undefined;
        }
        let type = accepts.find(x => this.isJsonMime(x));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime != null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
let CorrelationMatrixAPIService = class CorrelationMatrixAPIService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    calculateCorrelationMatrix(aladdinIds, currency, rc, pkg, date, observe = 'body', reportProgress = false) {
        if (aladdinIds === null || aladdinIds === undefined) {
            throw new Error('Required parameter aladdinIds was null or undefined when calling calculateCorrelationMatrix.');
        }
        if (currency === null || currency === undefined) {
            throw new Error('Required parameter currency was null or undefined when calling calculateCorrelationMatrix.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (aladdinIds) {
            aladdinIds.forEach((element) => {
                queryParameters = queryParameters.append('aladdinIds', element);
            });
        }
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (currency !== undefined && currency !== null) {
            queryParameters = queryParameters.set('currency', currency);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('post', `${this.basePath}/correlation-matrix`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
};
CorrelationMatrixAPIService.ɵfac = function CorrelationMatrixAPIService_Factory(t) { return new (t || CorrelationMatrixAPIService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
CorrelationMatrixAPIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CorrelationMatrixAPIService, factory: function (t) { return CorrelationMatrixAPIService.ɵfac(t); } });
CorrelationMatrixAPIService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
CorrelationMatrixAPIService = __decorate([ __param(1, Optional()), __param(1, Inject(BASE_PATH)), __param(2, Optional())
], CorrelationMatrixAPIService);

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
let PortfolioAnalysisAPIService = class PortfolioAnalysisAPIService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    calculateMultiPortfolio(body, rc, analytics, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (analytics) {
            analytics.forEach((element) => {
                queryParameters = queryParameters.append('analytics', element);
            });
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/analyze/portfolios`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    calculateMultiPortfolioAwResponse(body, rc, analytics, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (analytics) {
            analytics.forEach((element) => {
                queryParameters = queryParameters.append('analytics', element);
            });
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/analyze/portfolios-aw`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    calculateMultiTotalPortfolio(body, rc, analytics, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (analytics) {
            analytics.forEach((element) => {
                queryParameters = queryParameters.append('analytics', element);
            });
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/analyze/total-portfolios`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    calculateMultiTotalPortfolioAwResponse(body, rc, analytics, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (analytics) {
            analytics.forEach((element) => {
                queryParameters = queryParameters.append('analytics', element);
            });
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/analyze/total-portfolios-aw`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    calculatePortfolio(body, rc, analytics, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (analytics) {
            analytics.forEach((element) => {
                queryParameters = queryParameters.append('analytics', element);
            });
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/analyze/portfolio`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
};
PortfolioAnalysisAPIService.ɵfac = function PortfolioAnalysisAPIService_Factory(t) { return new (t || PortfolioAnalysisAPIService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
PortfolioAnalysisAPIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PortfolioAnalysisAPIService, factory: function (t) { return PortfolioAnalysisAPIService.ɵfac(t); } });
PortfolioAnalysisAPIService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
PortfolioAnalysisAPIService = __decorate([ __param(1, Optional()), __param(1, Inject(BASE_PATH)), __param(2, Optional())
], PortfolioAnalysisAPIService);

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
let RequestConfigurationAPIService = class RequestConfigurationAPIService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    getConfigContent(rc, observe = 'body', reportProgress = false) {
        if (rc === null || rc === undefined) {
            throw new Error('Required parameter rc was null or undefined when calling getConfigContent.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/config`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
};
RequestConfigurationAPIService.ɵfac = function RequestConfigurationAPIService_Factory(t) { return new (t || RequestConfigurationAPIService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
RequestConfigurationAPIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RequestConfigurationAPIService, factory: function (t) { return RequestConfigurationAPIService.ɵfac(t); } });
RequestConfigurationAPIService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
RequestConfigurationAPIService = __decorate([ __param(1, Optional()), __param(1, Inject(BASE_PATH)), __param(2, Optional())
], RequestConfigurationAPIService);

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
let SecurityAnalysisAPIService = class SecurityAnalysisAPIService {
    constructor(httpClient, basePath, configuration) {
        this.httpClient = httpClient;
        this.basePath = '/';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    details(body, rc, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/securities`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    multiResolve(body, rc, date, pkg, market, currency, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (market !== undefined && market !== null) {
            queryParameters = queryParameters.set('market', market);
        }
        if (currency !== undefined && currency !== null) {
            queryParameters = queryParameters.set('currency', currency);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/securities/multi-resolve`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    search(body, rc, date, pkg, skipCache, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (rc !== undefined && rc !== null) {
            queryParameters = queryParameters.set('rc', rc);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', date);
        }
        if (pkg !== undefined && pkg !== null) {
            queryParameters = queryParameters.set('pkg', pkg);
        }
        if (skipCache !== undefined && skipCache !== null) {
            queryParameters = queryParameters.set('skipCache', skipCache);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json'
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/securities/search`, {
            body: body,
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
};
SecurityAnalysisAPIService.ɵfac = function SecurityAnalysisAPIService_Factory(t) { return new (t || SecurityAnalysisAPIService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(BASE_PATH, 8), ɵngcc0.ɵɵinject(Configuration, 8)); };
SecurityAnalysisAPIService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SecurityAnalysisAPIService, factory: function (t) { return SecurityAnalysisAPIService.ɵfac(t); } });
SecurityAnalysisAPIService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BASE_PATH,] }] },
    { type: Configuration, decorators: [{ type: Optional }] }
];
SecurityAnalysisAPIService = __decorate([ __param(1, Optional()), __param(1, Inject(BASE_PATH)), __param(2, Optional())
], SecurityAnalysisAPIService);

const APIS = [CorrelationMatrixAPIService, PortfolioAnalysisAPIService, RequestConfigurationAPIService, SecurityAnalysisAPIService];

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var Facet;
(function (Facet) {
    Facet.TypeEnum = {
        CATEGORICAL: 'CATEGORICAL',
        RANGE: 'RANGE'
    };
})(Facet || (Facet = {}));

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var SingleExpostMetric;
(function (SingleExpostMetric) {
    SingleExpostMetric.ExPostTypeEnum = {
        TRRANN: 'TRR_ANN',
        STDDEV: 'STD_DEV',
        SHARPERATIO: 'SHARPE_RATIO',
        BETA: 'BETA',
        MAXDRAWDOWN: 'MAX_DRAWDOWN',
        UPMONTH: 'UP_MONTH',
        UPMONTHPCT: 'UP_MONTH_PCT',
        DOWNMONTH: 'DOWN_MONTH',
        DOWNMONTHPCT: 'DOWN_MONTH_PCT',
        MAX: 'MAX',
        MIN: 'MIN',
        UPCAPTURERATIO: 'UP_CAPTURE_RATIO',
        DOWNCAPTURERATIO: 'DOWN_CAPTURE_RATIO'
    };
    SingleExpostMetric.ExPostPeriodEnum = {
        ONEYEAR: 'ONE_YEAR',
        THREEYEAR: 'THREE_YEAR',
        FIVEYEAR: 'FIVE_YEAR',
        SEVENYEAR: 'SEVEN_YEAR',
        TENYEAR: 'TEN_YEAR',
        TOTAL: 'TOTAL'
    };
})(SingleExpostMetric || (SingleExpostMetric = {}));

/**
 * Wealth Web Endpoint
 * This is the Wealth Web Endpoint which provides portfolio analysis APIs for Tech for Flows products
 *
 * OpenAPI spec version: 1.12.0
 * Contact: GroupAWTDDDev@blackrock.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var Sort;
(function (Sort) {
    Sort.SortEnum = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
})(Sort || (Sort = {}));

var ApiModule_1;
let ApiModule = ApiModule_1 = class ApiModule {
    constructor(parentModule, http) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
    static forRoot(configurationFactory) {
        return {
            ngModule: ApiModule_1,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    }
};
ApiModule.ɵfac = function ApiModule_Factory(t) { return new (t || ApiModule)(ɵngcc0.ɵɵinject(ApiModule, 12), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient, 8)); };
ApiModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ApiModule });
ApiModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        CorrelationMatrixAPIService,
        PortfolioAnalysisAPIService,
        RequestConfigurationAPIService,
        SecurityAnalysisAPIService
    ] });
ApiModule.ctorParameters = () => [
    { type: ApiModule, decorators: [{ type: Optional }, { type: SkipSelf }] },
    { type: HttpClient, decorators: [{ type: Optional }] }
];
ApiModule = ApiModule_1 = __decorate([ __param(0, Optional()), __param(0, SkipSelf()),
    __param(1, Optional())
], ApiModule);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CorrelationMatrixAPIService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PortfolioAnalysisAPIService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RequestConfigurationAPIService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SecurityAnalysisAPIService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_PATH]
            }] }, { type: Configuration, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApiModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: [],
                providers: [
                    CorrelationMatrixAPIService,
                    PortfolioAnalysisAPIService,
                    RequestConfigurationAPIService,
                    SecurityAnalysisAPIService
                ]
            }]
    }], function () { return [{ type: ApiModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }, { type: ɵngcc1.HttpClient, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { APIS, ApiModule, BASE_PATH, COLLECTION_FORMATS, Configuration, CorrelationMatrixAPIService, Facet, PortfolioAnalysisAPIService, RequestConfigurationAPIService, SecurityAnalysisAPIService, SingleExpostMetric, Sort };

